





















import Vue from 'vue'
import NotFoundDesktop from '@/assets/svgs/not_found_desktop.svg?inline'
import NotFoundTablet from '@/assets/svgs/not_found_tablet.svg?inline'
import NotFoundMobile from '@/assets/svgs/not_found_mobile.svg?inline'
import Button from '@/components/atoms/Button.vue'

export default Vue.extend({
  name: 'NotFound',
  components: {
    NotFoundDesktop,
    NotFoundTablet,
    NotFoundMobile,
    Button,
  },
  methods: {
    goToSupportPage: function () {
      window.location.href = process.env.VUE_APP_LEARNER_SUPPORT_URL!
    },
  },
})

